export default __webpack_public_path__ + "static/media/logo.87d26334.svg";